// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9db4bac0","453":"fe015fdc"}[chunkId] + ".chunk.js";
};